/*
 * Lecteur vidéo Tiloa — pilote les cartes rendues par snippets/tiloa-video-card.liquid.
 *
 * Principes :
 * - Les contrôles natifs sont présents dans le HTML et ne sont retirés qu'ici :
 *   sans JavaScript, la vidéo reste lisible et accessible.
 * - Une seule vidéo joue à la fois, sauf dans un conteneur marqué
 *   data-video-autoplay="all" : ses cartes démarrent alors ensemble.
 * - Rien n'est téléchargé avant que la carte n'approche de l'écran.
 */
(function () {
  'use strict';

  var cards = [];
  // Le carrousel duplique les diapositives : un clone recopie les attributs
  // mais pas les écouteurs. On ne peut donc pas marquer l'élément lui-même,
  // sinon les clones passeraient pour déjà initialisés.
  var done = new WeakSet();

  function formatTime(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function pauseOthers(current) {
    cards.forEach(function (c) {
      if (c.video !== current && !groupeSimultane(c) && !c.video.paused) pauseAuto(c);
    });
  }

  // --- Lecture automatique au défilement ---------------------------------
  // La vidéo la plus proche du centre de l'écran démarre seule, en sourdine ;
  // les autres se mettent en pause. Le visiteur garde la main : une vidéo qu'il
  // a mise en pause ne redémarre pas toute seule, et le son qu'il a activé est
  // conservé. Rien ne démarre si le système demande de réduire les animations
  // ou si le navigateur est en économie de données.
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var conn = navigator.connection || navigator.webkitConnection;

  function autoplayPermis() {
    if (mqReduce && mqReduce.matches) return false;
    if (conn && conn.saveData) return false;
    return true;
  }

  function carteDe(video) {
    for (var i = 0; i < cards.length; i++) if (cards[i].video === video) return cards[i];
    return null;
  }

  // Mettre en pause pendant qu'un play() est encore en vol déclenche une
  // AbortError dans la console : on attend la fin de la promesse.
  function pauseAuto(card) {
    var arret = function () { card.pauseAuto = true; card.video.pause(); card.pauseAuto = false; card.enCours = null; };
    if (card.enCours && card.enCours.then) card.enCours.then(arret, arret);
    else arret();
  }

  // Part de la surface de la carte réellement visible : le carrousel de l'accueil
  // garde des diapositives hors écran sur le côté, elles ne doivent pas compter.
  function partVisible(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    var w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
    if (h <= 0 || w <= 0) return 0;
    return (h * w) / (r.height * r.width);
  }

  // Dans une bande qui défile horizontalement, la dernière carte est souvent
  // coupée sur le côté sans être « hors écran » pour autant : pour les groupes
  // simultanés on ne regarde donc que la visibilité verticale.
  function partVisibleVerticale(el) {
    var r = el.getBoundingClientRect();
    if (!r.height) return 0;
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return h <= 0 ? 0 : h / r.height;
  }

  function distanceAuCentre(el) {
    var r = el.getBoundingClientRect();
    return Math.abs((r.top + r.bottom) / 2 - window.innerHeight / 2);
  }

  // Un groupe peut demander que toutes ses vidéos démarrent ensemble : c'est le
  // cas de la bande de démonstration d'une fiche produit, où les trois clips se
  // lisent en parallèle. Ailleurs, la règle « une seule à la fois » s'applique.
  function groupeSimultane(card) {
    return !!(card.root.closest && card.root.closest('[data-video-autoplay="all"]'));
  }

  function lancer(card) {
    if (!card.video.paused && !card.video.ended) return;
    var v = card.video;
    if (v.preload === 'none') v.preload = 'metadata';
    if (!card.lectureVisiteur) { v.muted = true; v.loop = true; }
    card.auto = true;
    var p = v.play();
    if (p && p.then) {
      card.enCours = p;
      p.then(function () { card.enCours = null; }, function () { card.enCours = null; card.auto = false; });
    }
  }

  function majAutoplay() {
    if (document.hidden) {
      cards.forEach(function (c) { if (!c.video.paused) pauseAuto(c); });
      return;
    }
    if (!autoplayPermis()) return;

    var choisie = null;
    var meilleure = Infinity;
    cards.forEach(function (c) {
      var part = partVisible(c.root);
      c.visible = part;
      if (groupeSimultane(c)) {
        if (c.pauseVisiteur) return;
        if (partVisibleVerticale(c.root) >= 0.35) lancer(c); else if (!c.video.paused) pauseAuto(c);
        return;
      }
      if (part < 0.55 || c.pauseVisiteur) return;
      // Une vidéo lancée par le visiteur garde la priorité tant qu'elle est visible.
      var d = distanceAuCentre(c.root) - (c.lectureVisiteur && !c.video.paused ? 1e6 : 0);
      if (d < meilleure) { meilleure = d; choisie = c; }
    });

    cards.forEach(function (c) {
      if (c !== choisie && !groupeSimultane(c) && !c.video.paused) pauseAuto(c);
    });

    if (choisie) lancer(choisie);
  }

  var planifie = false;
  function planifierMaj() {
    if (planifie) return;
    planifie = true;
    window.requestAnimationFrame(function () { planifie = false; majAutoplay(); });
  }

  document.addEventListener('scroll', planifierMaj, { capture: true, passive: true });
  window.addEventListener('resize', planifierMaj, { passive: true });
  document.addEventListener('visibilitychange', planifierMaj);
  if (mqReduce && mqReduce.addEventListener) mqReduce.addEventListener('change', planifierMaj);

  function init(root) {
    var video = root.querySelector('.tiloa-vcard__video');
    if (!video || done.has(root)) return;
    done.add(root);

    var bar = root.querySelector('[data-vbar]');
    var play = root.querySelector('[data-vplay]');
    var toggle = root.querySelector('[data-vtoggle]');
    var seek = root.querySelector('[data-vseek]');
    var time = root.querySelector('[data-vtime]');
    var mute = root.querySelector('[data-vmute]');
    var full = root.querySelector('[data-vfull]');

    // Le script prend la main : on remplace les contrôles natifs par les nôtres.
    video.removeAttribute('controls');
    if (bar) bar.hidden = false;

    var card = { root: root, video: video };
    cards.push(card);

    var scrubbing = false;

    function syncPlayState() {
      var playing = !video.paused && !video.ended;
      root.classList.toggle('is-playing', playing);
      if (toggle) toggle.setAttribute('aria-label', playing ? 'Mettre en pause' : 'Reprendre la lecture');
    }

    function syncMuted() {
      root.classList.toggle('is-muted', video.muted);
      if (mute) mute.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
    }

    function togglePlay() {
      if (video.paused) {
        // Lecture demandée par le visiteur : elle prime sur la lecture automatique.
        card.lectureVisiteur = true;
        card.pauseVisiteur = false;
        pauseOthers(video);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        card.pauseVisiteur = true;
        video.pause();
      }
    }

    if (play) play.addEventListener('click', togglePlay);
    if (toggle) toggle.addEventListener('click', togglePlay);

    video.addEventListener('play', function () {
      pauseOthers(video);
      root.classList.add('has-started');
      card.auto = false;
      syncPlayState();
    });
    video.addEventListener('pause', syncPlayState);
    // La lecture automatique coupe le son elle-même : l'icône et son libellé
    // doivent suivre, sinon le bouton annonce l'inverse de ce qu'il fait.
    video.addEventListener('volumechange', syncMuted);
    video.addEventListener('ended', function () {
      root.classList.remove('has-started');
      syncPlayState();
    });

    video.addEventListener('timeupdate', function () {
      if (scrubbing || !video.duration) return;
      var pct = (video.currentTime / video.duration) * 100;
      if (seek) {
        seek.value = pct;
        seek.style.setProperty('--progress', pct + '%');
      }
      if (time) time.textContent = formatTime(video.currentTime);
    });

    video.addEventListener('loadedmetadata', function () {
      if (time) time.textContent = formatTime(0);
    });

    if (seek) {
      var startScrub = function () { scrubbing = true; };
      var applyScrub = function () {
        if (!video.duration) return;
        video.currentTime = (seek.value / 100) * video.duration;
        seek.style.setProperty('--progress', seek.value + '%');
      };
      seek.addEventListener('pointerdown', startScrub);
      seek.addEventListener('keydown', startScrub);
      seek.addEventListener('input', applyScrub);
      seek.addEventListener('change', function () { applyScrub(); scrubbing = false; });
      seek.addEventListener('pointerup', function () { scrubbing = false; });
    }

    if (mute) {
      mute.addEventListener('click', function () {
        video.muted = !video.muted;
        // Le son réglé par le visiteur n'est plus touché par la lecture automatique.
        card.lectureVisiteur = true;
        syncMuted();
      });
    }

    if (full) {
      full.addEventListener('click', function () {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (root.requestFullscreen) {
          root.requestFullscreen().catch(function () {});
        } else if (video.webkitEnterFullscreen) {
          // iPhone : seul l'élément vidéo accepte le plein écran.
          video.webkitEnterFullscreen();
        }
      });
    }

    // Au doigt : un appui sur la vidéo révèle les contrôles sans lancer la lecture.
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' && !e.target.closest('button, input')) {
        root.classList.add('show-controls');
        clearTimeout(root._vHide);
        root._vHide = setTimeout(function () { root.classList.remove('show-controls'); }, 3000);
      }
    });

    syncPlayState();
    syncMuted();
  }

  // Chargement paresseux : on ne demande les métadonnées qu'à l'approche de l'écran,
  // et on met en pause dès que la carte sort du champ.
  var io = null;
  var watched = new WeakSet();

  function observe() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-tiloa-video] .tiloa-vcard__video').forEach(function (v) {
        v.preload = 'metadata';
      });
      return;
    }
    if (!io) io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('.tiloa-vcard__video');
          if (!video) return;
          var card = carteDe(video);
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'metadata';
          } else {
            // Sortie d'écran : pause, et les choix du visiteur sont oubliés pour
            // que la vidéo puisse repartir seule au prochain passage.
            if (card) { card.pauseVisiteur = false; card.lectureVisiteur = false; }
            if (!video.paused) {
              if (card) pauseAuto(card); else video.pause();
            }
          }
        });
        planifierMaj();
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );
    document.querySelectorAll('[data-tiloa-video]').forEach(function (el) {
      if (watched.has(el)) return;
      watched.add(el);
      io.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tiloa-video]').forEach(init);
    observe();
    planifierMaj();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Le carrousel clone ses diapositives après coup : on rebalaie dès qu'une
  // carte apparaît dans le document.
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function (records) {
      if (pending) return;
      var nouveau = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-tiloa-video]') || n.querySelector('[data-tiloa-video]'));
        });
      });
      if (!nouveau) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        initAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // L'éditeur de thème recrée les sections à la volée.
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('load', initAll);
})();
